const Tooltip = ({
	getValue,
	tooltipStyles,
	tooltipData: { top, left, features },
}) => {
	if (!features.length) return;
	return (
		<ul
			className="tooltip"
			style={{
				...tooltipStyles,
				top,
				left,
			}}
		>
			{features.map((f) => {
				const name = f.name || f.properties?.NAME;
				const value = getValue(name, true);
				let valueCopy = '';
				if (value) {
					valueCopy = `: ${(getValue(name, true) * 100).toFixed(2)}%`;
				}
				return (
					<li key={name + valueCopy}>
						{name}
						{valueCopy}
					</li>
				);
			})}
		</ul>
	);
};
export default Tooltip;
